import React from 'react';
import styles from './GoogleSignIn.module.scss';
import Button from '@/components/Button';
import googleIcon from './gcal-logo.svg';

export default function GoogleSignIn(props) {
	return <Button { ...props } className={ styles.googleSignIn } icon={ googleIcon }>Sign in with Google</Button>;
}
